module.exports = __webpack_public_path__ + "static/media/om_eyeshape_hooded_brown.ac2dc2ee.png";